function getVisibleCartTargetRect(): DOMRect | null {
  const targets = document.querySelectorAll<HTMLElement>("[data-cart-target]");
  for (const target of targets) {
    const rect = target.getBoundingClientRect();
    if (rect.width > 0 && rect.height > 0) {
      return rect;
    }
  }
  return null;
}

export function playFlyToCartAnimation(
  sourceElement: HTMLElement | null | undefined,
  quantity = 1,
) {
  if (!sourceElement) return;

  const sourceRect = sourceElement.getBoundingClientRect();
  const targetRect = getVisibleCartTargetRect();
  if (!targetRect) return;

  const size = 40;
  const startX = sourceRect.left + sourceRect.width / 2 - size / 2;
  const startY = sourceRect.top + sourceRect.height / 2 - size / 2;
  const endX = targetRect.left + targetRect.width / 2 - size / 2;
  const endY = targetRect.top + targetRect.height / 2 - size / 2;
  const deltaX = endX - startX;
  const deltaY = endY - startY;

  const fly = document.createElement("div");
  fly.setAttribute("aria-hidden", "true");
  fly.className =
    "pointer-events-none fixed z-[9999] flex items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg ring-2 ring-primary/30";
  fly.style.left = `${startX}px`;
  fly.style.top = `${startY}px`;
  fly.style.width = `${size}px`;
  fly.style.height = `${size}px`;
  fly.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="8" cy="21" r="1"/>
      <circle cx="19" cy="21" r="1"/>
      <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>
    </svg>
  `;

  if (quantity > 1) {
    const badge = document.createElement("span");
    badge.className =
      "absolute -top-1 -right-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 font-bold text-[10px] text-destructive-foreground";
    badge.textContent = String(quantity);
    fly.appendChild(badge);
  }

  document.body.appendChild(fly);

  const animation = fly.animate(
    [
      {
        transform: "translate(0, 0) scale(1)",
        opacity: 1,
      },
      {
        transform: `translate(${deltaX * 0.55}px, ${deltaY * 0.35 - 28}px) scale(0.85)`,
        opacity: 1,
        offset: 0.55,
      },
      {
        transform: `translate(${deltaX}px, ${deltaY}px) scale(0.25)`,
        opacity: 0,
      },
    ],
    {
      duration: 680,
      easing: "cubic-bezier(0.33, 1, 0.68, 1)",
      fill: "forwards",
    },
  );

  animation.onfinish = () => fly.remove();
}
